export default __webpack_public_path__ + "static/media/helpTrans.b1a04b6e.png";